<template>
    <div class="step-three-container content-container">
        <span class="title">{{ $t('contact.page.message.label') }}</span>
        <div class="message-container">
            <TextInput class="input" v-model="object" :label="$t('contact.page.message.object')" />
            <div class="description-container">
                <textarea
                    @blur="toggleDescriptionFocus(false)"
                    @focus="toggleDescriptionFocus(true)"
                    class="description-input"
                    name="descriptif"
                    id="descriptif"
                    cols="30"
                    maxlength="4000"
                    v-model="description"
                />
                <span class="label" :class="description.trim() || descriptionFocus ? 'active-label' : ''">{{
                    $t('contact.page.message.description')
                }}</span>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { CONTACT } from '../store/mutation-types';
import { defineComponent } from 'vue';
import { store } from '@/plugins/store';
import TextInput from '@/components/ui-components/TextInput.vue';

export default defineComponent({
    components: { TextInput },
    data() {
        return {
            descriptionFocus: false,
        };
    },
    computed: {
        object: {
            get() { return store.state.contactState.objet;},
            set(value: string) { store.commit(`contactState/${CONTACT.SET_OBJET}`, value);}
        },
        description: {
            get() { return store.state.contactState.description;},
            set(value: string) { store.commit(`contactState/${CONTACT.SET_DESCRIPTION}`, value);}
        },
    },
    methods: {
        toggleDescriptionFocus(value: boolean) {
            this.descriptionFocus = value;
        },
    },
});
</script>

<style scoped>
.step-three-container {
    background-color: var(--white);
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12);
    max-height: calc(100vh - 415px);
    border-radius: 4px;
    padding: 24px;
    overflow-y: auto;
}
.title {
    color: var(--dark-blue);
    font-weight: var(--font-weight-medium);
    font-size: var(--font-size-medium);
}
.message-container {
    gap: 12px;
    display: flex;
    flex-direction: column;
}
.loader {
    align-self: center;
}
.description-container {
    position: relative;
    display: flex;
    border: 1px solid var(--medium-dark-grey);
    border-radius: 4px;
    padding: 11px 12px;
    align-items: center;
    height: 180px;
}
textarea {
    width: 100%;
    font-family: Roboto;
    border: none;
    outline: none;
    color: var(--black);
}
textarea {
    resize: none;
    height: 100%;
}
.label {
    left: 12px;
    position: absolute;
    pointer-events: none;
    transition: 0.2s ease all;
    padding: 2px;
    background-color: var(--white);
    color: var(--medium-dark-grey);
    top: 8px;
    font-size: var(--font-size-low-medium);
}
.active-label {
    left: 12px;
    top: -8px;
    font-size: var(--font-size-very-small);
}
</style>
